export function toSorted(array: unknown[], sortFn?: (a: unknown, b: unknown) => number) {
  return [...array].sort(sortFn);
}
